import { fromJS } from 'immutable'
import {
  LOB_DEACTIVATE_REQUEST,
  LOB_DEACTIVATE_SUCCESS,
  LOB_DEACTIVATE_FAILURE,
  LOB_DEACTIVATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LOB_DEACTIVATE_REQUEST:
      return state
        .set('isFetching', true)
    case LOB_DEACTIVATE_SUCCESS:
      return state
        .set('lobDeactivate', fromJS(action.payload.deletedLOB))
        .set('status', 200)
        .set('message', 'Deleted Successfully.')
        .set('isFetching', false)
    case LOB_DEACTIVATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('lobDeactivate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case LOB_DEACTIVATE_RESET:
      return state
        .delete('lobDeactivate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/lob/lob-deactivate-reducer.js